/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

export interface ITopDealRibbonProps {
    label?: string;
}

/**
 * Displays a promotional folded-corner ribbon over its positioned container.
 * @param props - Ribbon properties.
 * @returns The Top Deal ribbon.
 */
export const TopDealRibbon: React.FC<ITopDealRibbonProps> = ({ label = 'Even Lower Price' }) => (
    <div className='msc-top-deal-ribbon' aria-label={label}>
        <span className='msc-top-deal-ribbon__label'>
            Even <br /> Lower Price!
        </span>
    </div>
);

export default TopDealRibbon;
